module.exports = require("./lib/_stream_writable.js")



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/writable.js
// module id = 445
// module chunks = 1 4 5 6 8 9 10 12 14 15 21 22 24 27 28 58